import { getToken } from "../services/auth";

/** Wilco runs in ngft-ai (POST /help/crew/chat); without this address CO shows no Wilco. */
export const wilcoApiUrl = (): string | undefined => process.env.REACT_APP_AI_API_URL;

export type WilcoMessage = { role: "user" | "assistant"; content: string };

// ngft-ai answers from the last 10 messages and refuses more than 20, so a long chat sends only those.
const MAX_HISTORY = 10;

// The last messages of a long chat, starting with a question: cut at 10, a chat would start with an answer.
const recentHistory = (messages: WilcoMessage[]): WilcoMessage[] => {
  const recent = messages.slice(-MAX_HISTORY);
  return recent[0]?.role === "assistant" ? recent.slice(1) : recent;
};

export class WilcoError extends Error {
  constructor(readonly status: number) {
    super(`Wilco answered ${status}`);
    this.name = "WilcoError";
  }
}

/**
 * Sends the conversation, ending with the user's question. `page` is the tutorial page of the CO page the user is
 * on (no IDs); ngft-ai answers from the tutorial only.
 */
export const askWilco = async (
  messages: WilcoMessage[],
  page: string | undefined,
  language: string,
): Promise<string> => {
  const response = await fetch(`${wilcoApiUrl()}/help/crew/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${await getToken()}` },
    body: JSON.stringify({ messages: recentHistory(messages), page, language }),
  });
  if (!response.ok) throw new WilcoError(response.status);
  const { answer }: { answer?: unknown } = await response.json();
  // No status: a broken contract is a client-side error, so the caller reports it to Sentry
  if (typeof answer !== "string") throw new Error("Wilco answered without text");
  return answer;
};
